import { useState } from "react";
import { History, KeyRound, Send } from "lucide-react";
import { PanelTitle } from "../office/ui";
import { CodesInventory } from "./CodesInventory";
import { CodesHistory, CodesSend } from "./CodesSend";

const VIEWS = [["inventario", "Códigos por plataforma", KeyRound], ["enviar", "Enviar por WhatsApp", Send], ["historial", "Historial de envíos", History]];

export const AccessCodesPanel = () => {
  const [view, setView] = useState("inventario");
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div data-testid="codes-panel">
      <PanelTitle title="Códigos de acceso gratuito" text="Códigos de 30 días para CHALAN, MULTICONTACTOS, OPINADERO, SIN FRAUDE y SYNAPSIS. Créalos por plataforma, envíalos por WhatsApp a un distribuidor (combinando plataformas si quieres) y consulta a qué ID se entregó cada código." />
      <div className="mt-6 inline-flex flex-wrap gap-1 rounded-full border border-ink/15 bg-white p-1">
        {VIEWS.map(([id, label, Icon]) => (
          <button key={id} onClick={() => setView(id)} className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold transition-colors ${view === id ? "bg-ink text-white" : "hover:bg-paper"}`} data-testid={`codes-view-${id}`}>
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>
      <div className="mt-6">
        {view === "inventario" && <CodesInventory key={refreshKey} />}
        {view === "enviar" && <CodesSend onSent={() => setRefreshKey((k) => k + 1)} />}
        {view === "historial" && <CodesHistory key={refreshKey} />}
      </div>
    </div>
  );
};
